import { set, get } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  toggleSidebarNav,
  toggleDropdownNavItem,
  resetDropdownNavItems
} from '../../../../actions/components/reports/page-layout';
import NAV_KEYS from '../../../../../components/Reports/PageLayout/nav-keys';

const initialState = {
  sidebarNavExpanded: true,
  dropdownNavItemsExpanded: {
    [NAV_KEYS.OUTREACH_AGGREGATE]: true,
    [NAV_KEYS.GUEST_REPORT]: true
  }
};

const toggleSidbarNavHandler = action => ({
  [action.toString()]: ({ sidebarNavExpanded, ...state }) =>
    set('sidebarNavExpanded', !sidebarNavExpanded, state)
});

const toggleDropdownNavItemHandler = action => ({
  [action.toString()]: (
    { dropdownNavItemsExpanded, ...state },
    { payload: navItem }
  ) =>
    set(
      'dropdownNavItemsExpanded',
      {
        ...dropdownNavItemsExpanded,
        [navItem]: !get(navItem, dropdownNavItemsExpanded)
      },
      state
    )
});

const resetDropdownNavItemsHandler = action => ({
  [action.toString()]: set(
    'dropdownNavItemsExpanded',
    initialState.dropdownNavItemsExpanded
  )
});

export default createReducer(initialState, {
  ...toggleSidbarNavHandler(toggleSidebarNav),
  ...toggleDropdownNavItemHandler(toggleDropdownNavItem),
  ...resetDropdownNavItemsHandler(resetDropdownNavItems)
});
